import { render, staticRenderFns } from "./guidance.vue?vue&type=template&id=567c77c0&scoped=true"
import script from "./guidance.vue?vue&type=script&lang=js"
export * from "./guidance.vue?vue&type=script&lang=js"
import style0 from "./guidance.vue?vue&type=style&index=0&id=567c77c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c77c0",
  null
  
)

export default component.exports